"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var ScoreTab = function ScoreTab(_a) {
  var name = _a.score.name,
    colorClass = _a.colorClass,
    value = _a.value,
    selected = _a.selected,
    selectTab = _a.selectTab;
  return React.createElement("div", {
    className: "ths-score-tab" + selected,
    onClick: function onClick() {
      return selectTab(name);
    }
  }, React.createElement("div", {
    className: 'score-tab-name'
  }, name), React.createElement("div", {
    className: "score-tab-score score-" + colorClass + "-text"
  }, value));
};
exports.ScoreTab = ScoreTab;